import * as React from 'react'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import Link from '~/client/components/Link'

export default function PageFooter() {
  const links = [
    ['Terms', '/terms'],
    ['Privacy', '/privacy'],
    ['Security', '/security'],
    // ['Status', '/status'],
    ['Docs', '/docs'],
    ['Contact', '/contact'],
    ['Pricing', '/pricing'],
    // ['Training', '/training'],
    // ['Blog', '/blog'],
    ['About', '/about'],
  ]
  return (
    <Container sx={{pt: 2}}>
      <Divider/>
      <Box sx={{
        p: 2,
        display: {xs: 'block', md: 'flex'},
        alignItems: 'flex-start',
        justifyContent: 'center'
      }}>
        <Typography
          variant="body2"
          noWrap
          sx={{mb: 2, mr: 2}}
        >© 2022 DataPal, Inc.</Typography>
        <Box sx={{
          flexGrow: '1',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
          whiteSpace: 'nowrap',
          gap: '12px',
        }}>
          {links.map(([title, href]) =>
            <Link
              key={title}
              to={href}
            >{title}</Link>
          )}
        </Box>
      </Box>
    </Container>
  )
}
